import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import LawFirmForm from '@/modules/law_firm/components/LawFirmForm.vue';
import { LawFirmCreate } from '@/modules/law_firm/LawFirm';


export default /*@__PURE__*/_defineComponent({
  __name: 'LawFirmCreate',
  setup(__props) {

const router = useRouter();
const { $gettext } = useGettext();
const lawFirm = ref<Partial<LawFirmCreate>>({});

const saved = (law_firm) => {
	Flash.success($gettext('Extern partner tillagd'));
	router.push({
		name: 'law_firm.edit',
		params: { id: law_firm.id },
	});
};

const cancel = () => {
	router.push({ name: 'law_firm.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LawFirmForm, {
    "page-title": _unref($gettext)('Ny extern partner'),
    "law-firm": lawFirm.value,
    onSaved: saved,
    onCancel: cancel,
    "for-create": true
  }, null, 8, ["page-title", "law-firm"]))
}
}

})